import React from "react";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useModalTools } from "@ui/modals/modalContext";
import { AuthModal } from "./authModal";

export function useAuthModalBlocker(): (action: () => void) => void {
	const currentProfile = useCurrentProfile();
	const { createModal } = useModalTools();

	const blockGuest = (action: () => void): void => {
		if (currentProfile) {
			action();
		} else {
			createModal((close) => <AuthModal close={close} />);
		}
	};

	return blockGuest;
}
